import React from 'react'
import dayjs from 'dayjs'
import {
  DatePicker as BaseDatePicker,
  DatePickerProps,
  RangePickerProps,
} from 'src/antd'

import { object } from 'src/utils/object'

import { useDatePickerBaseProps } from './DatePickerBase'

const { RangePicker: BaseRangePicker } = BaseDatePicker

type TWhDatePickerProps = Omit<DatePickerProps, 'dateRender'>

const WhDatePicker = ({
  onChange,
  popupClassName,
  ...props
}: TWhDatePickerProps) => {
  const { showTime } = props
  // A HOOK, not the plain call this used to be: the week-number column is
  // delivered one way with the design toggle off and another with it on, so
  // this component has to subscribe to the mode rather than read it once.
  const baseProps = useDatePickerBaseProps({ popupClassName })

  return (
    <BaseDatePicker
      {...object(!showTime && { format: 'LL' })}
      getPopupContainer={(trigger) => trigger.parentElement!}
      {...props}
      {...baseProps}
      onChange={(dayjsDate, dateString) => {
        onChange?.(
          dayjsDate,
          // eslint-disable-next-line no-nested-ternary
          showTime
            ? dateString
            : dayjsDate
            ? dayjs(dayjsDate).format('YYYY-MM-DD')
            : ''
        )
      }}
    />
  )
}

type TWHRangePickerProps = Omit<RangePickerProps, 'dateRender'> & {
  showTime?: boolean
}

const WhRangePicker = ({
  onChange,
  popupClassName,
  ...props
}: TWHRangePickerProps) => {
  const { showTime } = props
  const baseProps = useDatePickerBaseProps({ popupClassName })
  return (
    <BaseRangePicker
      {...object(!showTime && { format: 'LL' })}
      {...props}
      {...baseProps}
      onChange={(dayjsDate, dateString) => {
        onChange?.(
          dayjsDate,
          // eslint-disable-next-line no-nested-ternary
          showTime
            ? dateString
            : dayjsDate
            ? [
                dayjs(dayjsDate?.[0]).format('YYYY-MM-DD'),
                dayjs(dayjsDate?.[1]).format('YYYY-MM-DD'),
              ]
            : ['', '']
        )
      }}
    />
  )
}

WhDatePicker.RangePicker = WhRangePicker

const DATE_PICKER_FORMAT = 'LL'
const DATE_PICKER_FORMAT_TIME = 'LLL'

WhDatePicker.FORMATS = { DATE_PICKER_FORMAT, DATE_PICKER_FORMAT_TIME }

export { WhDatePicker }
